import { useRef, useState, useEffect } from "react";
import { debounce } from "../utils/debounce.js";
const useSize = (ref) => {
  const ticking = useRef(false);
  const [size, setSize] = useState();
  useEffect(() => {
    if (typeof ResizeObserver !== "undefined") {
      const resizeObserver = new ResizeObserver((entries) => {
        if (!ticking.current) {
          window.requestAnimationFrame(() => {
            setSize(entries[0].target.getBoundingClientRect());
            ticking.current = false;
          });
        }
        ticking.current = true;
      });
      if (ref == null ? void 0 : ref.current) {
        resizeObserver.observe(ref == null ? void 0 : ref.current);
      }
      return () => {
        if (ref == null ? void 0 : ref.current) {
          resizeObserver.unobserve(ref.current);
        } else {
          resizeObserver.disconnect();
        }
      };
    } else if (typeof window === "object") {
      const handleLayoutEvent = () => {
        (ref == null ? void 0 : ref.current) && setSize(ref.current.getBoundingClientRect());
      };
      const events = ["layoutchange", "resize", "orientationchange"];
      const debounceMs = 10;
      const [debouncedCallback, teardown] = debounce(handleLayoutEvent, debounceMs);
      events.forEach((eventName) => window.addEventListener(eventName, debouncedCallback));
      debouncedCallback();
      return () => {
        teardown();
        events.forEach((eventName) => window.removeEventListener(eventName, debouncedCallback));
      };
    }
  }, [ref == null ? void 0 : ref.current]);
  return size;
};
export {
  useSize
};
//# sourceMappingURL=useSize.js.map
